import { render, staticRenderFns } from "./PpeDeptManagerDictList.vue?vue&type=template&id=e2e7875e&"
import script from "./PpeDeptManagerDictList.vue?vue&type=script&lang=js&"
export * from "./PpeDeptManagerDictList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports